module.exports = __webpack_public_path__ + "static/index/assets/media/video.5c6910a0.mp4";